import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj, PAYMENT_METHODS } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { ITrainingProgram } from 'src/app/interfaces/country';
import { pageKey, toNumber } from 'src/app/services/mapping.service';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-training-program',
  templateUrl: './add-training-program.component.html',
  styleUrls: ['./add-training-program.component.scss']
})
export class AddTrainingProgramComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  form: FormGroup;
  name: AbstractControl;
  shortName: AbstractControl;
  description: AbstractControl;
  order: AbstractControl;


  constructor(public dialogRef: MatDialogRef<AddTrainingProgramComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public store: List
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      name: [null, Validators.required],
      description: [null],
      shortName: [null, Validators.required],
      order: [null, Validators.required]
    });
    this.shortName = this.form.controls['shortName'];
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.order = this.form.controls["order"]
  }

  ngOnInit() {
    this.buildForm();
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { name, description, shortName, order } = f;
      const { levelKey, key, degreeKey } = this.data;
      const item: ITrainingProgram = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        shortName: shortName,
        description: description,
        status: statusObj.active,
        totalLevel: toNumber(order),
        degreeRef: this.ds.degreeRef().doc(`${degreeKey}`).ref,
        degreeKey: degreeKey,
        levelRef: this.ds.levelRef().doc(`${levelKey}`).ref,
        levelKey: levelKey,
        programRef: this.ds.adprogramCollectRef().doc(`${key}`).ref,
        programKey: key,
      };

      this.store.save(this.ds.trainingProgramRef(), item, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Training program has been created successfully.', 'done', { duration: 2000 });
          this.form.reset();
          this.inputEl.nativeElement.focus();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });
    }
  }

}
